import React, { ComponentProps } from 'react';

import ActivityMultiUserChange from './ActivityMultiUserChange';
import ActivityCard from '../ActivityCard';

type MultiUserChangeActivityCardProps = ComponentProps<typeof ActivityCard> &
  ComponentProps<typeof ActivityMultiUserChange>;

/**
 * MultiUserChangeActivityCard component. Describes a multi-user change activity.
 */
const MultiUserChangeActivityCard = React.forwardRef<
  HTMLDivElement,
  MultiUserChangeActivityCardProps
>(
  (
    {
      defaultIsTruncated,
      addedUsers,
      removedUsers,
      userChangeDescription,
      ...props
    },
    ref,
  ) => {
    return (
      <ActivityCard ref={ref} {...props}>
        <ActivityMultiUserChange
          defaultIsTruncated={defaultIsTruncated}
          addedUsers={addedUsers}
          removedUsers={removedUsers}
          userChangeDescription={userChangeDescription}
        />
      </ActivityCard>
    );
  },
);

MultiUserChangeActivityCard.displayName = 'MultiUserChangeActivityCard';

MultiUserChangeActivityCard.propTypes = {
  ...ActivityCard.propTypes,
  ...ActivityMultiUserChange.propTypes,
};

export default MultiUserChangeActivityCard;
